export default function WhatIsInstant() {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-4xl mx-auto px-4">
        <h2 className="text-3xl font-bold text-gray-900 mb-8">即日発行クレジットカードとは？</h2>
        
        <div className="prose prose-lg max-w-none">
          <p className="text-gray-700 leading-relaxed mb-6">
            即日発行クレジットカードとは、申し込んだその日のうちにカード番号が発行され、すぐに利用できるクレジットカードのことです。従来のクレジットカードは申し込みから実際にカードが手元に届くまで1〜2週間かかるのが一般的でしたが、即日発行カードなら最短10秒でカード番号が発行されます。
          </p>
          
          <div className="bg-teal-50 border-l-4 border-teal-600 p-6 rounded-lg mb-8">
            <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center gap-2">
              <i className="ri-lightbulb-line text-teal-600"></i>
              即日発行の仕組み
            </h3>
            <ul className="space-y-3 text-gray-700">
              <li className="flex items-start gap-2">
                <i className="ri-check-line text-teal-600 mt-1 flex-shrink-0"></i>
                <span><strong>オンライン申込み：</strong>スマホやPCから24時間いつでも申し込み可能</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-check-line text-teal-600 mt-1 flex-shrink-0"></i>
                <span><strong>最短即日審査：</strong>AIによる自動審査で最短10秒〜数分で審査完了</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-check-line text-teal-600 mt-1 flex-shrink-0"></i>
                <span><strong>アプリで即時発行：</strong>専用アプリでカード番号をすぐに確認できる</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-check-line text-teal-600 mt-1 flex-shrink-0"></i>
                <span><strong>すぐに利用可能：</strong>ネットショッピングやスマホ決済で即日利用開始</span>
              </li>
            </ul>
          </div>

          <p className="text-gray-700 leading-relaxed mb-6">
            プラスチックカードは後日郵送で届きますが、カード番号さえあればオンライン決済やApple Pay、Google Payなどのスマホ決済にすぐに登録して使えます。急な出費や今すぐカードが必要な場面で非常に便利です。
          </p>

          <div className="grid md:grid-cols-2 gap-6 mt-8">
            <div className="bg-gray-50 p-6 rounded-lg">
              <h4 className="font-bold text-gray-900 mb-3 flex items-center gap-2">
                <i className="ri-time-line text-teal-600"></i>
                従来のカード
              </h4>
              <ul className="space-y-2 text-sm text-gray-700">
                <li className="flex items-start gap-2">
                  <i className="ri-arrow-right-s-line text-gray-400 mt-0.5"></i>
                  <span>申込みから到着まで1〜2週間</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-arrow-right-s-line text-gray-400 mt-0.5"></i>
                  <span>カードが届くまで利用不可</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-arrow-right-s-line text-gray-400 mt-0.5"></i>
                  <span>郵送での受け取りが必要</span>
                </li>
              </ul>
            </div>

            <div className="bg-teal-50 p-6 rounded-lg border-2 border-teal-600">
              <h4 className="font-bold text-gray-900 mb-3 flex items-center gap-2">
                <i className="ri-flashlight-line text-teal-600"></i>
                即日発行カード
              </h4>
              <ul className="space-y-2 text-sm text-gray-700">
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-teal-600 mt-0.5"></i>
                  <span>最短10秒でカード番号発行</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-teal-600 mt-0.5"></i>
                  <span>申込み当日から利用可能</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-teal-600 mt-0.5"></i>
                  <span>アプリですぐに確認できる</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
